<template>
    <!-- 案例详情 -->
    <div>
        <myheader :messages="parentMessage"></myheader>
        <!--  -->
        <div class="aboutopcomm aboutopcomm2 w1750 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                <div class="h">{{newslist.title}}</div>
                <div class="em"></div>
                <div class="t">来自：{{newslist.author}}   {{ parseTime(newslist.addtime, '{y}/{m}/{d}') }} </div>
                <div class="p">{{newslist.brief}}</div>
            </div>
        </div>
        <div class="newsdatabox wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
            <div class="textbox">
                <div class="data" v-html="newslist.content">
                       
                </div>
                <div class="more" @click="newsler"></div>
            </div>
            <div class="list wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <div class="tit">其它文章</div>
                <div class="mk">
                    <div class="li" v-for="(item,index) in otherlist" :key="index" @click="otherclick(item.id)">
                        <div class="h">{{item.title}}</div>
                        <div class="p">{{item.brief}}</div>
                        <div class="t">{{ parseTime(newslist.addtime, '{y}/{m}/{d}') }}</div>
                    </div>
                </div>
            </div>   
        </div>
        <!--  -->
        <myfooter></myfooter>
    </div>
</template>

<script>
    import myfooter from './footer.vue'
    import myheader from './header.vue'
    
    export default {
        data() {
            return {
                parentMessage: 3,
                newslist: [],
                querInfo: {
                    classifyid: '',
                    pageNum: 2,
                    pageSize: 3
                },
                otherlist: []
            }
        },
        created() {
            this.newsdoor(this.$route.query.id);
            this.othernews()
        },
        methods: {
            async newsdoor(id) {
                var url = `/api/news/${id}`
                const { data: res } = await this.$http.post(url)
                
                this.newslist = res.data
            },
            async othernews(){
                var url = `/api/news/list?classifyid=${this.querInfo.classifyid}&pageNum=${this.querInfo.pageNum}&pageSize=${this.querInfo.pageSize}`
                const { data: res } = await this.$http.post(url)
                
                this.otherlist = res.data.rows
            },
            parseTime(time, pattern) {
                  if (arguments.length === 0 || !time) {
                    return null
                  }
                  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
                  let date
                  if (typeof time === 'object') {
                    date = time
                  } else {
                    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
                      time = parseInt(time)
                    } else if (typeof time === 'string') {
                      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
                    }
                    if ((typeof time === 'number') && (time.toString().length === 10)) {
                      time = time * 1000
                    }
                    date = new Date(time)
                  }
                  const formatObj = {
                    y: date.getFullYear(),
                    m: date.getMonth() + 1,
                    d: date.getDate(),
                    h: date.getHours(),
                    i: date.getMinutes(),
                    s: date.getSeconds(),
                    a: date.getDay()
                  }
                  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
                    let value = formatObj[key]
                    // Note: getDay() returns 0 on Sunday
                    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
                    if (result.length > 0 && value < 10) {
                      value = '0' + value
                    }
                    return value || 0
                  })
                  return time_str
            },
            newsler(){
               this.$router.push('/news').catch(()=>{ })
               window.scrollTo(0,0); 
            },
            otherclick(id){
                const { href } = this.$router.resolve({
                    path: '/newsdata',
                    query: { id }
                })
                window.open(href, '_blank', 'noopener')
            }
        },
        components: {
        	myheader, myfooter
        }
    }
</script>

<style>

</style>